var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatahubLogoColorLoadingPendulum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "datahub-logo-color-loading_pendulum",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 180",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_gradient",
    x1: 83.06,
    y1: 68.88,
    x2: 98.74,
    y2: 40.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd3163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5663"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_gradient",
    x1: 91.08,
    y1: 126.64,
    x2: 35.79,
    y2: 50.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efb700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue_gradient",
    x1: 50.22,
    y1: 96.82,
    x2: 144.42,
    y2: 17.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1890ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18b5ff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "red_mask"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 34,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 26,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -34,
    width: 34,
    height: 34,
    transform: "rotate(170)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -34,
    width: 34,
    height: 34,
    transform: "rotate(280)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -34,
    width: 34,
    height: 34,
    transform: "rotate(225)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "red_mask_cap"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: -30,
    r: 4,
    transform: "rotate(10)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -30,
    r: 4,
    transform: "rotate(170)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "yellow_mask"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 49,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 41,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -49,
    width: 49,
    height: 49,
    transform: "rotate(20)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -49,
    width: 49,
    height: 49,
    transform: "rotate(70)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -45,
    r: 4,
    transform: "rotate(20)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -45,
    r: 4,
    transform: "rotate(160)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "blue_mask"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 64,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 56,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -64,
    width: 64,
    height: 64,
    transform: "rotate(275)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -64,
    width: 64,
    height: 64,
    transform: "rotate(220)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -60,
    r: 4,
    transform: "rotate(5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -60,
    r: 4,
    transform: "rotate(220)",
    fill: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(90,90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "red",
    fill: "url(#red_gradient)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "red_arc",
    r: 34,
    mask: "url(#red_mask)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: 0,
    to: 360,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    id: "yellow",
    fill: "url(#yellow_gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "yellow_joint",
    x: -4,
    y: 45,
    width: 8,
    height: 35,
    transform: "rotate(57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "yellow_arc",
    r: 49,
    mask: "url(#yellow_mask)"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 80,
    r: 4,
    transform: "rotate(57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "yellow_satellite",
    cy: 80,
    r: 10,
    transform: "rotate(57)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "-5; 80; -5",
    calcMode: "spline",
    keySplines: "0.25 0.1 0.25 1.0; 0.25 0.1 0.25 1.0",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    id: "blue",
    fill: "url(#blue_gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blue_joint",
    x: -4,
    y: -80,
    width: 8,
    height: 20,
    transform: "rotate(57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "blue_arc",
    r: 64,
    mask: "url(#blue_mask)"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: -80,
    r: 4,
    transform: "rotate(57)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "blue_satellite",
    cy: -80,
    r: 10,
    transform: "rotate(57)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0; -35; 0",
    keyTimes: "0; 0.1; 1",
    dur: "6s",
    repeatCount: "indefinite"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatahubLogoColorLoadingPendulum);
export default __webpack_public_path__ + "static/media/datahub-logo-color-loading_pendulum.5acd3761fd5a52d6fa3f9fd7fdabf5d3.svg";
export { ForwardRef as ReactComponent };